var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.9365 12.2898C21.9365 16.4398 19.7265 21.4998 13.0665 21.4998C8.06113 21.533 3.97504 17.5051 3.93652 12.4998C3.97504 7.49437 8.06113 3.46646 13.0665 3.49972C15.1372 3.5074 17.145 4.21189 18.7665 5.49972C18.8785 5.59125 18.9474 5.72533 18.9565 5.86972C18.9571 6.01581 18.8995 6.15613 18.7965 6.25972C18.1455 6.85492 17.5247 7.48237 16.9365 8.13972C16.7654 8.32802 16.4787 8.35408 16.2765 8.19972C15.3526 7.516 14.2253 7.1637 13.0765 7.19972C10.1218 7.19972 7.72652 9.595 7.72652 12.5498C7.72652 15.5045 10.1218 17.8998 13.0765 17.8998C16.0765 17.8998 17.3465 16.6198 18.0065 14.3498H13.4365C13.1604 14.3498 12.9365 14.1259 12.9365 13.8498V11.1998C12.9365 10.9236 13.1604 10.6998 13.4365 10.6998H21.4365C21.6667 10.6983 21.8609 10.8709 21.8865 11.0998C21.9236 11.4953 21.9403 11.8925 21.9365 12.2898Z",
    fill: "#4753EB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/Google.9ff5c20bfdc805f3d4f75106d4e8f921.svg";
export { ForwardRef as ReactComponent };